exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination-container[data-v-72233bcd] {\n\tbackground: #fff;\n\tpadding: 10px 0;\n}\n.pagination-container.hidden[data-v-72233bcd] {\n\tdisplay: none;\n}\n", ""]);

// exports
